import { useMasterStore } from '@/stores/masterStore'
import { BuildingMaster } from '@/types/Facet'

export function useFetchMasterData() {
  const masterStore = useMasterStore()

  /**
   * 種別ごとのマスター取得
   * @param buildingType 1=マンション, 2=戸建て
   * @param retryCount 何回までリトライするか
   */
  const fetchMaster = async (buildingType: number, retryCount = 2): Promise<void> => {
    const { $fireBangApiDomain } = useNuxtApp();
    const url = `${$fireBangApiDomain}/api/net/compare/masters?buildingType=${buildingType}`
    let attempt = 0
    while (attempt < retryCount) {
      const { data, error } = await useFetch(url, {
        method: 'GET', 
      })
      if (data.value) {
        // データstore格納
        if (buildingType === 1) masterStore.setMansion(data.value as BuildingMaster)
        else if (buildingType === 2) masterStore.setHouse(data.value as BuildingMaster)
        return
      }
      if (error.value) {
        const { statusCode } = error.value;
        console.log('マスター取得APIエラーステータスコード:', statusCode);
        throw showError({ statusCode});
      }
      attempt++
    }
    // リトライ超過時
    console.error(`buildingType ${buildingType} マスター取得リトライ超過`)
  }

  /**
   * 両方のマスターをまとめて取得
   */
  const fetchAllMasters = async (retryCount = 2) => {
    await fetchMaster(1, retryCount)
    await fetchMaster(2, retryCount)
  }

  return {
    fetchMaster,
    fetchAllMasters
  }
}